import React, { Component } from "react";

export default class SummaryDetail extends Component {
  render() {
    return <div className={this.props.customClass}>{this.props.children}</div>;
  }
}
